'use client';
import React, { useState, useCallback } from 'react';
import ZeroCost from "../../assets/Zero_cost_1.svg";
import ZeroCost2 from "../../assets/Zero_cost_2.svg";
import './VerifierPage.css';
import { Header } from '../PageTemplate/Header';
import { Footer } from '../PageTemplate/Footer';

const VerifierPage = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');
  const baseVideoSrc =
    'https://www.youtube.com/embed/p6oro5MYtHc?si=gHsx-qF2K5VrvG-U&mute=1&playsinline=1';

  const startVideo = useCallback(() => {
    setIsVideoPlaying(true);
    setVideoSrc((prev) => {
      if (!prev) {
        return baseVideoSrc.includes('?')
          ? `${baseVideoSrc}&autoplay=1`
          : `${baseVideoSrc}?autoplay=1`;
      }
      if (!/autoplay=1/.test(prev)) {
        return prev.includes('?') ? `${prev}&autoplay=1` : `${prev}?autoplay=1`;
      }
      return prev;
    });
  }, [baseVideoSrc]);

  const handlePlayPillClick = (e) => {
    e.stopPropagation();
    startVideo();
  };

  const handleBannerClick = (e) => {
    if (isVideoPlaying) return;
    // If CTA clicked, don't start video
    if (e.target.closest('.ie-cta')) return;
    startVideo();
  };

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        background: '#ffffff',
        zoom: 0.97,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          background: 'white',
          overflow: 'hidden',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          display: 'inline-flex',
        }}
      >
        <Header />

        {/* SECTION 2 – Hire with Certainty */}
        <div className="vt-hire-wrapper" aria-label="Verifiers main content">
          <div className="vt-hire-inner">
            <div className="vt-hire-container">
              <div className="vt-hire-card">
                <div className="vt-hire-bg">
                  {/* <div className="vt-hire-bg-circle-1"></div>
                  <div className="vt-hire-bg-circle-2"></div>
                  <div className="vt-hire-bg-circle-3"></div>
                  <div className="vt-hire-bg-circle-4"></div>
                  <div className="vt-hire-bg-overlay"></div> */}
                </div>
                <div className="vt-hire-layout">
                  <div className="vt-hire-content">
                    <div className="vt-hero-pill">For Verifiers</div>
                    <div className="vt-hire-title">Hire with Certainty</div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 32,
                        alignItems: 'flex-start',
                        width: '100%',
                      }}
                    >
                      <div className="vt-hire-body">
                        Verify candidate qualifications instantly and securely,
                        <br></br>
                        directly from the source.
                      </div>
                      <div className="vt-hire-cta-row">
                        <div className="vt-hire-cta" data-property-1="Default">
                          <a aria-label="Start Verifying Today — opens in a new tab" href='https://verify.verifytt.gov.tt/' target="_blank" >
                            <div className="vt-hire-cta-inner">
                              <div className="vt-hire-cta-text">
                                Start Verifying Today
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="vt-hire-illustration" aria-hidden="false">
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer.svg"
                      alt="Issuer illustration"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* VERIFIED HANDSHAKE SECTION */}
        <div className="vh-section" role="region" aria-label="The Verified Handshake">
          <div className="vh-section-inner">
            <div className="vh-container">
              <div className="vh-header" aria-label="Verified Handshake header">
                <div className="vh-title-row">
                  <div className="vh-title">The Verified Handshake</div>
                </div>
                <div className="vh-description">
                  In an economy of strangers, you need to know exactly who is
                  walking through your door. Stop interviewing &quot;strangers.&quot; Start
                  meeting candidates with a Verified Introduction, direct from
                  source.
                </div>
              </div>

              <div className="vh-cards-row" aria-label="Verified Handshake benefits">
                <div className="vh-card vh-card--outlined-blue" aria-label="Zero Fraud">
                  <div className="vh-card-header">
                    <div className="vh-card-icon">
                      <div className="vh-card-icon-square" aria-hidden="true">
                        <img
                          class="vh-card-icon-img1"
                            aria-hidden="true"
                          src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/common_in_all.svg"
                          alt="varifier_1_1"
                        />
                        <img
                          class="vh-card-icon-img2"
                          src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/varifier_1_1.svg"
                          alt="varifier_1_1"
                           aria-hidden="true"
                        />
                      </div>
                    </div>
                    <div className="vh-card-title">Zero Fraud</div>
                  </div>
                  <div className="vh-card-text">
                    Impossible to fake or Photoshop
                  </div>
                </div>

                <div className="vh-card vh-card--outlined-blue" data-property-1="Default" aria-label="Zero Wait">
                  <div className="vh-card-header">
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        class="vh-card-icon-img1"
                        src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/varifier_1_2.svg"
                        alt="varifier_1_2"
                        aria-hidden="true"
                      />
                      <img
                        class="vh-card-icon-img2"
                        src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/ZeroWait.svg"
                        alt="varifier_1_2"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="vh-card-title">Zero Wait</div>
                  </div>
                  <div className="vh-card-text">
                    Verification happens in real-time.
                  </div>
                </div>

                <div className="vh-card vh-card--outlined-blue" data-property-1="Default" aria-label="Zero Cost">
                  <div className="vh-card-header">
                    <div
                    aria-hidden="true"
                    style={{
                        width: 24,
                        height: 24,
                        position: 'relative',
                        overflow: 'hidden',
                      }}>
                      <img
                        class="vh-card-icon-img1"
                        src={ZeroCost}
                        alt="varifier_1_3"
                        aria-hidden="true"
                      />
                      <img
                        class="vh-card-icon-img2"
                        src={ZeroCost2}
                        alt="varifier_1_3"
                       
                        aria-hidden="true"
                      />
                    </div>
                    <div className="vh-card-title">Zero Cost</div>
                  </div>
                  <div className="vh-card-text">
                    The basic verification service is free to use
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HOW IT WORKS VISUAL FLOW */}
        <div className="hiwv-outer" role="region" aria-label="How it works">
          <div className="hiwv-panel">
            <div className="hiwv-left">
              <div className="hiwv-left-text">
                <div className="hiwv-title">
                  3-Step illustrative flow for Academic certificates
                </div>
                <div className="hiwv-subtitle">
                  Every step is engineered to protect your reputation and
                  simplify your operations
                </div>
              </div>

              <div className="hiwv-illustration-card" aria-hidden="false">
                <div className="hiwv-illustration-bg"></div>
                <div className="hiwv-illustration-inner">
                  <img
                    src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/varifier_sec_3_1.svg"
                    alt="How it works"
                  />
                </div>
              </div>
            </div>

            <div className="hiwv-right" aria-label="Steps">
              {/* Step 01 */}
              <div className="hiwv-step" aria-label="Step 01: Connect">
                <div className="hiwv-step-badge">
                  <div className="hiwv-step-number">01</div>
                </div>
                <div className="hiwv-step-content">
                  <div className="hiwv-step-title">Connect</div>
                  <div className="hiwv-step-text">
                    We integrate securely with your existing student
                    record systems
                  </div>
                </div>
              </div>

              <div className="hiwv-spacer hiwv-arrow" aria-hidden="true"></div>

              {/* Step 02 */}
              <div className="hiwv-step" aria-label="Step 02: Issue">
                <div className="hiwv-step-badge">
                  <div className="hiwv-step-number">02</div>
                </div>
                <div className="hiwv-step-content">
                  <div className="hiwv-step-title">Issue</div>
                  <div className="hiwv-step-text hiwv-step-text--column">
                    Generate and distribute digital certificates instantly to an
                    entire graduating cohort.
                  </div>
                </div>
              </div>

              <div className="hiwv-spacer hiwv-arrow" aria-hidden="true" ></div>

              {/* Step 03 */}
              <div className="hiwv-step" aria-label="Step 03: Verify">
                <div className="hiwv-step-badge">
                  <div className="hiwv-step-number">03</div>
                </div>
                <div className="hiwv-step-content">
                  <div className="hiwv-step-title">Verify</div>
                  <div className="hiwv-step-text hiwv-step-text--column">
                    When employers check a graduate&apos;s claim, the system
                    confirms automatically
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* VIDEO BANNER */}
        {/* <div className="ie-section" role="region" aria-label="Verification demo">
          <div
            className={
              'ie-banner' + (isVideoPlaying ? ' is-playing' : '')
            }
            onClick={handleBannerClick}
          >
            <div className="ie-bg-wrapper">
              <div className="ie-bg-overlay"></div>
            </div>

            <div className="ie-video-bg">
              <iframe
                id="vtDemoVideo"
                src={videoSrc || undefined}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                aria-label="VerifyTT demo video"
              ></iframe>
            </div>

            <div className="ie-video-overlay" aria-hidden={isVideoPlaying}></div>

            <div className="ie-content">
              <div className="ie-heading-group">
                <div className="ie-eyebrow">Watch the Verification Process</div>
                <div className="ie-subtitle"  aria-label="Play 15-second demo">15-second demo</div>
              </div>

              <div className="ie-play-pill" onClick={handlePlayPillClick}>
                <div className="ie-play-icon-wrapper">
                  <div className="ie-play-icon-inner">
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Play.svg"
                      alt="play"
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>

              <div className="ie-cta" data-property-1="Default">
                <div className="ie-cta-inner">
                  <div className="ie-cta-text">Start Verifying Today</div>
                </div>
              </div>
            </div>

            <div className="ie-height-spacer"></div>
          </div>
        </div> */}

        <Footer />
      </div>
    </div>
  );
};

export default VerifierPage;
